import MuiTypography from '@mui/material/Typography';
import { theme } from '@src/common/styles/Theme';
import type { ComponentProps, ElementType } from 'react';

type Props = Pick<
  ComponentProps<typeof MuiTypography>,
  'variant' | 'children' | 'id' | 'style' | 'className'
> & { component?: ElementType; color?: string };

export const Typography = (props: Props) => {
  return <MuiTypography {...props} />;
};

export const ErrorTypography = (props: Props) => {
  return <Typography {...props} style={{ color: theme.palette.error.error }} />;
};
